(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-meta-description"] && !Shopify.designMode) return;
  try {
    
  const accordion = document.getElementById("rte--accordion");
  function toggleAccordion() { 
    const cta = document.querySelector(".read--cta");
    if (accordion.classList.contains("clamp--div")) {
      accordion.classList.remove("clamp--div")
      cta.innerText = "Read Less";
    }
    else {
      accordion.classList.add("clamp--div");
      cta.innerText = "Read More";
    }
  }
  document.querySelector("#rte--accordion").addEventListener("click", (e) => {
    toggleAccordion();
  });
  document.querySelector(".read--cta").addEventListener("click", (e) => {
    toggleAccordion();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-popup"] && !Shopify.designMode) return;
  try {
    
  function closePopup(className) {
    document.getElementsByClassName(className)[0].classList.remove("active")
  }
  function openPopup(className) {
    document.getElementsByClassName(className)[0].classList.add("active")
  }
  function setPopupCookie() {
    document.cookie = "popupLoaded=true; expires=Session; path=/";
  }
  function isPopupLoaded() {
    return document.cookie.indexOf("popupLoaded=true") === -1;
  }
  document.getElementsByClassName("custom-popup-close")[0].addEventListener("click", (e) => {
    closePopup("custom-popup")
  })
  document.addEventListener("DOMContentLoaded", (event) => {
    if(isPopupLoaded()) {
      setTimeout(()=> {
        openPopup("custom-popup")
        setPopupCookie()
      }, 2000)
    }
  });
  document.addEventListener('click', function(event) {
    const container = document.getElementsByClassName("custom-popup-body")[0];
    if (event.target !== container && !container.contains(event.target)) {
      closePopup("custom-popup");
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const isDymanicPopupClosed = sessionStorage.getItem("isDymanicPopupClosed");
    if(!isDymanicPopupClosed) {
      const noticePopup = document.getElementById("dynamic__popup");
      noticePopup && setTimeout(() => {
        noticePopup.classList.add("active");
        sessionStorage.setItem("isDymanicPopupClosed", true);
      }, 5000);
    }
    const closeDynamicPopupIcon = document.querySelector(".popup__body > svg");
    closeDynamicPopupIcon && closeDynamicPopupIcon.addEventListener("click", closeDynamicPopup)
  })
  document.getElementById("dynamic__popup").addEventListener("click", function (event) {
      if (event.target === this) {
          closeDynamicPopup();
      }
  });
  const closeDynamicPopup = () => {
    const noticePopup = document.getElementById("dynamic__popup");
    if(noticePopup) {
      noticePopup.classList.remove("active");
      sessionStorage.setItem("isDymanicPopupClosed", true);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exit-intent-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('mouseout', (evt) => {
    const isExitIntentPopupClosed = sessionStorage.getItem("isExitIntentPopupClosed");
    const isDymanicPopupActive = document.getElementById("dynamic__popup")?.classList?.contains("active");
    if(!isExitIntentPopupClosed && !isDymanicPopupActive && evt.toElement == null && evt.relatedTarget == null) {
      const noticePopup = document.getElementById("dynamic__popup__exit");
      if(noticePopup) {
        noticePopup.classList.add("active");
        sessionStorage.setItem("isExitIntentPopupClosed", true);
        const closeDynamicPopupIcon = document.querySelector("#dynamic__popup__exit .popup__body > svg");
        closeDynamicPopupIcon && closeDynamicPopupIcon.addEventListener("click", closeDynamicPopup)
      }
    }
  })
  document.getElementById("dynamic__popup__exit").addEventListener("click", function (event) {
      if (event.target === this) {
          closeDynamicPopup();
      }
  });
  const closeDynamicPopup = () => {
    const noticePopup = document.getElementById("dynamic__popup__exit");
    if(noticePopup) {
      noticePopup.classList.remove("active");
      sessionStorage.setItem("isExitIntentPopupClosed", true);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
     $('.Footer__Block.Footer__Block--links.closed').click(function(e) {
       if ($(this).hasClass('opened')) {
        $(this).removeClass('opened').addClass('closed');
      } else {
        $(this).removeClass('closed').addClass('opened');
      }
     })
  }, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const data = [...document.querySelectorAll('.associated_products .list_item')];
  data.forEach(item => {
    item.addEventListener("click", () => {
      const value = item.getAttribute("data-selection")
      if(value) {
        item.setAttribute("data-selection", value === "false" ? "true" : "false");
      }
    })
  });

  document.addEventListener("DOMContentLoaded", () => {
    // const target = document.querySelector(".Buyers_Responsibility p");
    const target = document.querySelector(".Product__InfoWrapper .ProductForm__QuantitySelector .ProductForm__Label");

    if (!target) return;

    const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio === 0) {
          // Fully outside
          if (!document.body.classList.contains("EnableFloaterATC")) {
            document.body.classList.add("EnableFloaterATC");
          }
        } else if (entry.intersectionRatio === 1) {
          // Fully inside
          if (document.body.classList.contains("EnableFloaterATC")) {
            document.body.classList.remove("EnableFloaterATC");
          }
        }
      });
    },
    {
      root: null,        
      threshold: [0, 1],  
    }
  );

    observer.observe(target);
  });
  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-note"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const isNoticeClosed = sessionStorage.getItem("isNoticeClosed");
    if(!isNoticeClosed) {
      const noticePopup = document.getElementById("notice__popup");
      noticePopup && noticePopup.classList.add("active");
    }
    const closeIcon = document.querySelector(".notice__popup > svg");
    closeIcon && closeIcon.addEventListener("click", closeNoticePopup)
  })
  const closeNoticePopup = () => {
    const noticePopup = document.getElementById("notice__popup");
    if(noticePopup) {
      noticePopup.classList.remove("active");
      sessionStorage.setItem("isNoticeClosed", true);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
